import { type ColumnPresetId } from "../../../domain/column-presets";
import { locateRow } from "../../../domain/find";
import { isGroup } from "../../../domain/sections";
import { getEditorStore } from "../../../domain/store";

export function insertGroupFromPalette(): void {
  const { document, selection, insertGroup } = getEditorStore();
  let index = document.sections.length;
  if (selection.kind === "group") {
    const current = document.sections.findIndex(
      section => section.id === selection.groupId,
    );
    if (current >= 0) {
      index = current + 1;
    }
  } else if (selection.kind === "row") {
    const located = locateRow(document.sections, selection.rowId);
    if (located?.location.parent === "document") {
      index = located.location.sectionIndex + 1;
    } else if (located?.location.parent === "group") {
      const { groupId } = located.location;
      const groupIndex = document.sections.findIndex(
        section => section.id === groupId,
      );
      if (groupIndex >= 0) {
        index = groupIndex + 1;
      }
    }
  }
  insertGroup(index);
}

export function insertRowFromPalette(presetId: ColumnPresetId): void {
  const { document, selection, insertRow } = getEditorStore();
  if (selection.kind === "group") {
    const group = document.sections.find(
      section => isGroup(section) && section.id === selection.groupId,
    );
    if (group && isGroup(group)) {
      insertRow({ groupId: group.id, rowIndex: group.rows.length }, presetId);
    }
    return;
  }
  if (selection.kind === "row") {
    const located = locateRow(document.sections, selection.rowId);
    if (located?.location.parent === "group") {
      insertRow(
        {
          groupId: located.location.groupId,
          rowIndex: located.location.rowIndex + 1,
        },
        presetId,
      );
      return;
    }
    if (located?.location.parent === "document") {
      insertRow(located.location.sectionIndex + 1, presetId);
      return;
    }
  }
  insertRow(document.sections.length, presetId);
}
